import { TextField, Grid, Typography, Button, Box } from "@material-ui/core";
import { getDate, isBefore, jalaliToUtc } from "../../utils/TimeUtils";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import "../../assets/css/calendar.css";
import { utils } from "react-modern-calendar-datepicker";
import { BLUE_PRIMARY, GREEN_PRIMRY, WHITE } from "../../utils/const";
import { convertNumbers } from "../../utils/ConvertNumbers";
import useCustomState from "../../hooks/State";
import { Autocomplete } from "@material-ui/lab";
import { useSelector } from "react-redux";
import { useMountAPI } from "../../hooks/APICall";
import { useHistory } from "react-router";
import Call from "../../service/API";

const showDate = (date) => {
  return date.year + "/" + date.month + "/" + date.day;
};

const ChartFilters = (props) => {
  const chartTypes = [
    { title: "ستونی", id: "bar" },
    { title: "خطی", id: "line" },
  ];

  const visualizationType = [
    { title: "مصرف روزانه", id: "daily" },
    { title: "مصرف تجمعی", id: "cumulative" },
  ];

  const selectedType = useCustomState(chartTypes[0]);
  const selectedVisualizationType = useCustomState(visualizationType[0]);

  const typeChanged = (e, newValue) => {
    selectedType.handleChange(newValue);
    props.chartTypeChanged(newValue.id);
  };

  const visualizationTypeChanged = (e, newValue) => {
    selectedVisualizationType.handleChange(newValue);
    props.visualizationTypeChanged(newValue.id);
  };

  const selectedCategory = useCustomState(
    props.renderCategories
      ? props.categories[props.categories.length - 1]
      : {
          name: "همه",
          id: null,
        }
  );

  const categoryChanged = (e, newValue) => {
    selectedCategory.handleChange(newValue);
  };

  const users = useCustomState([]);
  const usersIsLoading = useCustomState(true);

  const selectedUser = useCustomState({ name: "همه", id: null });

  const userChanged = (e, newValue) => {
    selectedUser.handleChange(newValue);
  };

  const projects = useCustomState([]);
  const projectsIsLoading = useCustomState(true);
  const selectedProject = useCustomState({ name: "همه", id: null });

  const projectChanged = (e, newValue) => {
    selectedProject.handleChange(newValue);
  };

  const counterTypes = useCustomState([]);
  const counterTypesIsLoading = useCustomState(true);
  const selectedCounterType = useCustomState({ name: "همه", id: null });

  const counterTypeChanged = (e, newValue) => {
    selectedCounterType.handleChange(newValue);
  };

  const counters = useCustomState([]);
  const countersIsLoading = useCustomState(true);
  const selectedCounter = useCustomState({ name: "همه", id: null });

  const counterChanged = (e, newValue) => {
    selectedCounter.handleChange(newValue);
  };

  const history = useHistory();

  const usersUtils = {
    page: 1,
    count: 100000,
    username: "",
    lastname: "",
    phoneNumber: "",
    isLoading: usersIsLoading,
    history: history,
    users: users,
    props: props,
  };

  const projectsUtils = {
    page: 1,
    count: 100000,
    projectNameFilter: "",
    projectCreateDateFilter: "",
    isLoading: projectsIsLoading,
    projects: projects,
    history: history,
    props: props,
  };

  const counterTypesUtils = {
    page: 1,
    count: 100000,
    typeName: "",
    typeDate: "",
    isLoading: counterTypesIsLoading,
    types: counterTypes,
    history: history,
    props: props,
  };

  const countersUtils = {
    page: 1,
    count: 100000,
    isLoading: countersIsLoading,
    history: history,
    counters: counters,
    props: props,
  };

  useMountAPI(fetchUsers, usersUtils);
  useMountAPI(fetchProjects, projectsUtils);
  useMountAPI(fetchCounterTypes, counterTypesUtils);
  useMountAPI(fetchCounters, countersUtils);

  const applyFilters = () => {
    props.applyFilters({
      chartType: selectedType.value.id,
      category: selectedCategory.value,
      user: selectedUser.value,
      project: selectedProject.value,
      type: selectedCounterType.value,
      counter: selectedCounter.value,
    });
  };

  const startRenderer = ({ ref }) => (
    <TextField
      error={props.startError.value.error}
      helperText={props.startError.value.text}
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(props.start.value))}
      fullWidth
      variant="standard"
      label="از تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );

  const endRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(props.end.value))}
      fullWidth
      variant="standard"
      label="تا تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );

  const renderFromDate = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <DatePicker
          value={props.start.value}
          onChange={props.startChanged}
          renderInput={startRenderer}
          // colorPrimary="#0eca2d" // added this
          colorPrimary={BLUE_PRIMARY}
          calendarClassName="custom-calendar" // and this
          calendarTodayClassName="custom-today-day" // also this
          shouldHighlightWeekends
          locale="fa"
          maximumDate={getDate(0, "Next")}
        />
      </Grid>
    );
  };

  const renderToDate = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <DatePicker
          value={props.end.value}
          onChange={props.endChanged}
          renderInput={endRenderer}
          // colorPrimary="#0eca2d" // added this
          colorPrimary={BLUE_PRIMARY}
          calendarClassName="custom-calendar" // and this
          calendarTodayClassName="custom-today-day" // also this
          shouldHighlightWeekends
          locale="fa"
          maximumDate={getDate(1, "Next")}
        />
      </Grid>
    );
  };

  const renderChartType = () => {
    if (props.renderChartType) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={typeChanged}
            value={selectedType.value}
            options={chartTypes}
            getOptionLabel={(option) => option.title}
            // disableCloseOnSelect
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="نوع نمودار"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderCategories = () => {
    if (props.renderCategories) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={categoryChanged}
            value={selectedCategory.value}
            options={props.categories}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="دسته"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderUsers = () => {
    if (props.renderUsers) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={userChanged}
            value={selectedUser.value}
            options={users.value}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="کاربر"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderProjects = () => {
    if (props.renderProjects) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={projectChanged}
            value={selectedProject.value}
            options={projects.value}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="پروژه"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderCounterTypes = () => {
    if (props.renderTypes) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={counterTypeChanged}
            value={selectedCounterType.value}
            options={counterTypes.value}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="نوع کنتور"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderCounters = () => {
    if (props.renderCounters) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={counterChanged}
            value={selectedCounter.value}
            options={counters.value}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="کنتور"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const renderVisualizationType = () => {
    if (props.renderVisualizationType) {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          style={{
            paddingRight: "16px",
            paddingLeft: "16px",
            paddingTop: "8px",
            paddingBottom: "8px",
          }}
        >
          <Autocomplete
            onChange={visualizationTypeChanged}
            value={selectedVisualizationType.value}
            options={visualizationType}
            getOptionLabel={(option) => option.title}
            // disableCloseOnSelect
            renderInput={(params) => (
              <TextField
                // error={counterCategoryError.value.error}
                // helperText={counterCategoryError.value.text}
                {...params}
                label="نوع مصرف"
                variant="standard"
              />
            )}
          />
        </Grid>
      );
    } else {
      return null;
    }
  };

  const ConsumptionAttributes = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <TextField
          aria-readonly={true}
          value={props.consumptionData?.total?.toLocaleString(undefined, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}
          variant="standard"
          label="مصرف کل در بازه"
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
          disabled
        ></TextField>
      </Grid>
    );
  };

  const ConsumptionAttributesT = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        <TextField
          aria-readonly={true}
          value={props.consumptionData?.avg?.toLocaleString(undefined, {
            minimumFractionDigits: 1,
            maximumFractionDigits: 1,
          })}
          variant="standard"
          label="متوسط مصرف"
          InputLabelProps={{
            style: {
              fontFamily: "Vazir",
            },
          }}
          size="small"
          disabled
        ></TextField>
      </Grid>
    );
  };

  const renderApplyButton = () => {
    return (
      <Grid
        item
        xs={12}
        sm={6}
        md={4}
        lg={3}
        style={{
          paddingRight: "16px",
          paddingLeft: "16px",
          paddingTop: "8px",
          paddingBottom: "8px",
        }}
      >
        {/* <Box textAlign={"center"}> */}
        <Button
          onClick={applyFilters}
          style={{ backgroundColor: GREEN_PRIMRY, width: "80%", color: WHITE }}
        >
          اعمال فیلترها
        </Button>
        {/* </Box> */}
      </Grid>
    );
  };

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      style={{
        width: "100%", // height: "80px",
        border: "1px solid #333333",
        borderRadius: "8px",
      }}
    >
      <Grid item container>
        {renderFromDate()}
        {renderToDate()}
        {renderChartType()}
        {renderCategories()}
        {renderUsers()}
        {renderProjects()}
        {renderCounterTypes()}
        {renderCounters()}
        {renderVisualizationType()}
        {props.consumptionData ? ConsumptionAttributes() : null}
        {props.consumptionData ? ConsumptionAttributesT() : null}
        {renderApplyButton()}
      </Grid>
    </Grid>
  );
};

export default ChartFilters;

const processUsers = (users) => {
  const results = [{ name: "همه", id: null }];
  let data;
  users.map((user) => {
    data = {
      id: user.user_id,
      name: user.user_name + " " + user.user_lastname,
      phoneNumber: user.user_phone,
      counters: user.All_water_meter_with_this_user_id,
      date: user.user_create_date,
    };
    results.push(data);
  });
  return results;
};

const fetchUsers = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const username = utils.username;
  const lastname = utils.lastname;
  const phoneNumber = utils.phoneNumber;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const users = utils.users;
  const props = utils.props;

  if (!props.renderUsers) {
    isLoading.handleChange(false);
  } else {
    const data = {
      page: page,
      count: count,
      user_name: username,
      user_lastname: lastname,
      user_phone: phoneNumber,
    };

    Call("POST", "users/admin/getAllUsers", data)
      .then((response) => {
        // console.log("users", response);
        if (response.data.code == 200) {
          const us = response.data.data.users;
          users.handleChange(processUsers(us));
          isLoading.handleChange(false);
        }
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          if (data.code === 403) {
            history.push("/admin/login");
          }
        }
      });
  }
};

const processProjects = (projects) => {
  const results = [];
  results.push({ name: "همه", id: null });
  let data, date;
  // console.log("projects", projects);
  projects.map((project) => {
    date = project.water_meter_project_start_date;
    data = {
      name: project.water_meter_project_name,
      user: "",
      location: project.water_meter_project_title,
      date: date,
      counters: project.water_meters_with_this_id.All_water_meter_with_this_id,
      id: project.water_meter_project_id,
    };
    results.push(data);
  });
  return results;
};

const fetchProjects = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const projectNameFilter = utils.projectNameFilter;
  const projectCreateDateFilter = utils.projectCreateDateFilter;
  const isLoading = utils.isLoading;
  const projects = utils.projects;
  const history = utils.history;
  const props = utils.props;

  if (!props.renderProjects) {
    isLoading.handleChange(false);
  } else {
    const data = {
      page: page,
      count: count,
      water_meter_project_name: projectNameFilter,
      water_meter_project_create_date: projectCreateDateFilter,
    };
    Call("POST", "WaterMeterProjectsURL/admin/getAll", data)
      .then((response) => {
        // console.log("projects", response);
        if (response.data.code == 200) {
          const ps = response.data.data;
          projects.handleChange(processProjects(ps));
          isLoading.handleChange(false);
        }
      })
      .catch((error) => {
        // console.log(error);
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          if (data.code === 403) {
            history.push("/admin/login");
          }
        }
        isLoading.handleChange(false);
      });
  }
};

const processCounterTypes = (counterTypes) => {
  const results = [];
  results.push({ name: "همه", id: null });
  let data;
  counterTypes.map((counterType) => {
    data = {
      id: counterType.water_meter_type_id,
      name: counterType.water_meter_type_name,
      projects: counterType.All_project_with_this_type,
      counters: counterType.All_counter_with_this_type,
      category: counterType.water_meter_tag.water_meter_tag_name,
      date: counterType.water_meter_type_create_date,
      images: counterType.water_meter_type_files,
    };
    results.push(data);
  });
  return results;
};

const fetchCounterTypes = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const typeName = utils.typeName;
  const typeDate = utils.typeDate;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const types = utils.types;
  const props = utils.props;

  if (!props.renderTypes) {
    isLoading.handleChange(false);
  } else {
    const data = {
      page: page,
      count: count,
      water_meter_type_name: typeName,
      water_meter_type_create_date: typeDate,
    };

    Call("POST", "WaterMeterTypes/admin/getAll", data)
      .then((response) => {
        // console.log("counterTypes", response);
        if (response.data.code == 200) {
          const ts = response.data.data.results;
          types.handleChange(processCounterTypes(ts));
        }
        isLoading.handleChange(false);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          if (data.code == 403) {
            history.push("/admin/login");
          }
        }
        isLoading.handleChange(false);
      });
  }
};

const processCounters = (counters) => {
  const results = [];
  results.push({ name: "همه", id: null });
  let data;
  counters.map((counter) => {
    data = {
      id: counter.water_meter_serial,
      name: counter.water_meter_name,
      serial: counter.water_meter_serial,
      type: counter.water_meter_type_info.water_meter_type_name,
      category: counter.water_meter_tag_info.water_meter_tag_name,
      project: counter.water_meter_project_info.project_name,
      validation: counter.water_meter_validation,
      activation: counter.water_meter_activation,
    };
    results.push(data);
  });
  return results;
};

const fetchCounters = (utils) => {
  const page = utils.page;
  const count = utils.count;
  const isLoading = utils.isLoading;
  const history = utils.history;
  const counters = utils.counters;
  const props = utils.props;

  if (!props.renderCounters) {
    isLoading.handleChange(false);
    return;
  } else {
    const data = {
      page: page,
      count: count,
      user_id: null,
      project_id: null,
    };

    Call("POST", "watermeters/admin/getAll", data)
      .then((response) => {
        // console.log("counters", response);
        if (response.data.code == 200) {
          const cs = response.data.data;
          counters.handleChange(processCounters(cs));
        }
        isLoading.handleChange(false);
      })
      .catch((error) => {
        if (error.response) {
          const data = error.response.data;
          // console.log(data);
          if (data.code == 403) {
            history.push("/admin/login");
          }
        }
        isLoading.handleChange(false);
      });
  }
};
